import type { FaireProductEntity } from "../../entity_types/product";

export const p_3vexegtd3s: FaireProductEntity = {
  token: "p_3vexegtd3s",
  type: "product",
  name: "Do Not Disturb Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/95f9369d8ceae9af9411ffed168237cfa8e2bc497f90734165ad6edca5a6a16b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ba1665ab2ecb0ebe4b26cba5f50021732044e2ec1601983d67a39975ee8728f.jpeg",
    "https://cdn.faire.com/fastly/c7f111493fd15092d6d32b3ea3a1dc45d02f15dc5277e977173d27c2e79a415f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/46847d6ad5e36a737eea3cdd5ded2bf6ac3545e5e1aff5637739410df748a6f5.jpeg",
    "https://cdn.faire.com/fastly/6e50acc8294400adbf34c95287dffeb35fae48b020feb240a26e5bd5c31ccc90.jpeg"
  ],
  priceDollars: 3.38,
  description: "When “Do Not Disturb” is less of a suggestion and more of a lifestyle, you'll want a pair of these bright red foot bags. Kick your feet up and let the world know you're definitely not available—unless it’s an emergency… but even then, probably not. 😝\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:07.203Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
